import { render, staticRenderFns } from "./Btc.vue?vue&type=template&id=6d02303c&"
import script from "./Btc.vue?vue&type=script&lang=js&"
export * from "./Btc.vue?vue&type=script&lang=js&"
import style0 from "./Btc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports